import React from 'react';
import { CaseTenantData } from './types';
import './CaseTenantBadge.css';

interface CaseTenantBadgeProps {
  tenant?: CaseTenantData;
  variant?: 'row' | 'stacked';
}

/**
 * Marks a case as belonging to a white-label partner rather than to Coepi.
 *
 * Renders nothing for a Coepi case, which is the overwhelming majority, so the
 * queue does not grow a column of empty badges. That asymmetry is the point:
 * the badge appearing at all is the signal.
 *
 * It matters because the customer behind one of these has never heard of
 * Coepi. An agent replying in our name, or sending them to app.coepi.eu, undoes
 * the white label in a single message.
 */
const CaseTenantBadge: React.FC<CaseTenantBadgeProps> = ({ tenant, variant = 'row' }) => {
  if (!tenant) return null;

  return (
    <span
      className={`case-tenant-badge case-tenant-badge--${variant}`}
      data-testid="case-tenant-badge"
      title={
        tenant.supportEmail
          ? `White-label case: this customer knows us as ${tenant.tenantName}. Their support address is ${tenant.supportEmail}.`
          : `White-label case: this customer knows us as ${tenant.tenantName}, not Coepi.`
      }
    >
      {tenant.tenantName}
    </span>
  );
};

export default CaseTenantBadge;
